<template>
    <base-page :model="model.heroSection">
        <div class="error-page">
            <div v-if="model.body" v-html="model.body"></div>
        </div>
        <div class="buttons">
            <Button class="go-back-button" @click="handleGoBack">Go to previous page</Button>
            <Button as-child><a href="/">Go to home page</a></Button>
        </div>
    </base-page>
</template>
<script setup lang="ts">
import BasePage from '@/components/Common/BasePage/BasePage.vue';
import { IErrorPageProps } from './ErrorPage.model';
import { Button } from '@/components/ui/button';


const { model } = defineProps<IErrorPageProps>();

const handleGoBack = () => {
    window.history.back()
}
</script>
<style lang="scss" scoped>
.error-page {
    border-radius: 0 0 24px 24px;
    border: 1px solid lightgray;
    border-top: 0;
    padding: 24px 30px;

    display: flex;
    flex-direction: column;

    h1 {
        font-weight: 700;
        font-size: 32px;
    }

    h5 {
        font-weight: 600;
        font-size: 16px;
    }
}

.wrapper {
    display: flex;
    justify-content: space-between;

    .error-image {
        max-width: 500px;
    }
}

.buttons {
    margin-top: 15px;
    display: flex;
    gap: 20px
}

.go-back-button {
    cursor: pointer;
}
</style>